module.exports = __webpack_public_path__ + "img/buy-car1536x864.7a8b4138.png";